<template>
  <div :class="['info-item x-flex-align', { 'flex-start': start }]">
    <div class="x-left-option-text" :style="{ width: labelWidth }">
      <span :class="['x-grey-text', { 'x-option': optionText }]">{{ title }}</span>
    </div>
    <span class="x-grey-text">：</span>
    <slot>
      <span v-if="password">
        <i>******</i>
        <ux-button v-if="showButton" class="x-margin-l" type="primary" text @click="showPass"
          >{{ $t('HT.editPasswd') }}</ux-button
        >
      </span>
      <el-tooltip
        v-if="showToop"
        effect="dark"
        :content="info"
        popper-class="x-info-item-tooltip"
        placement="top"
      >
        <span ref="info" :class="['x-dark-content x-flex-one', textClass]">{{ info }}</span>
      </el-tooltip>
      <span v-else ref="info" :class="['x-dark-content x-flex-one', textClass]">{{
        info || ''
      }}</span>
    </slot>
  </div>
</template>

<script>
import editPassword from '../../views/template/editPassword'; // 修改密码
export default {
  name: 'MyInfoItem',
  components: {
    editPassword
  },
  props: {
    labelWidth: {
      // 左侧标题宽度
      type: String,
      default: 'auto'
    },
    title: {
      // 左侧标题
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: true
    },
    optionText: {
      // label文字对齐(仅支持四个字)
      type: Boolean,
      default: true
    },
    info: {
      // 右侧内容
      type: [String, Number],
      default: ''
    },
    password: {
      // 修改密码
      type: Boolean,
      default: false
    },

    start: {
      // 垂直居中方式(默认居中)
      type: Boolean,
      default: false
    },
    line: {
      // 分几行显示(支持1-2行)
      type: Number,
      default: 1 // 默认1行
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showToop: false, // 是否超出显示提示框
      textClass: 'x-overflow-hidden'
    };
  },
  mounted() {
    this.isOverflow();
  },

  methods: {
    /**
     * 修改密码弹窗
     */
    showPass() {
      this.$uxModal.show({
        title: this.$t('HT.editPasswd'),
        content: (h) => {
          return h(editPassword, {
            props: {
              isAdmin: this.isAdmin
            }
          });
        },
        confirm: (val) => {
          this.$emit('editPass', val);
        }
      });
    },

    /**
     * 判断是否超出
     */
    isOverflow() {
      this.textClass = this.line === 2 ? 'x-overflow-2' : 'x-overflow-hidden';
      setTimeout(() => {
        if (this.info && this.$refs.info) {
          let scroll = this.line === 2 ? this.$refs.info.scrollHeight : this.$refs.info.scrollWidth;
          let text = this.line === 2 ? this.$refs.info.offsetHeight : this.$refs.info.offsetWidth;
          if (scroll > text) {
            this.showToop = true;
          } else {
            this.showToop = false;
          }
        }
      }, 500);
    }
  },

  watch: {
    info() {
      this.isOverflow();
    }
  }
};
</script>

<style lang="scss" scoped>
.info-item {
  margin-bottom: 28px;
  overflow: hidden;
  line-height: 19px;

  .x-grey-text {
    height: 19px;
    line-height: 19px;
  }
}

.info-item.flex-start {
  align-items: flex-start;
}
</style>
